var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useCallback, useRef } from "react";
import { useCombineRefs } from "../../hooks";
import { DarkNeutralsColorNames } from "../../theme";
import { getColorByName } from "../../utils/color";
import { useCursorPosition } from "../../utils/hooks";
import { BaseTextField } from "../inputs";
import clsx from "clsx";
import styles from "./PhoneNumberTextField.module.scss";
const format = (phoneNumber) => {
    if (phoneNumber.length <= 3)
        return phoneNumber;
    const part1 = phoneNumber.slice(0, 3);
    if (phoneNumber.length <= 6)
        return `${part1}  ${phoneNumber.slice(3)}`;
    const part2 = phoneNumber.slice(3, 6);
    return `${part1}  ${part2}  ${phoneNumber.slice(6)}`;
};
const unformat = (rawPhoneNumber) => {
    return rawPhoneNumber.replace(/\s/g, "");
};
const calcMaxLength = (maxLength) => {
    if (maxLength == undefined)
        return undefined;
    const fakeString = "x".repeat(maxLength);
    const formattedFakeString = format(fakeString);
    return formattedFakeString.length;
};
const PhoneNumberTextFieldFC = (_a, ref) => {
    var { datatestidPhonenumber, prefixNumber, suffixClassName, suffix: suffixProp, value, onChange, placeholder, maxLength: maxLengthProp } = _a, props = __rest(_a, ["datatestidPhonenumber", "prefixNumber", "suffixClassName", "suffix", "value", "onChange", "placeholder", "maxLength"]);
    const innerRef = useRef(null);
    const textFieldRef = useCombineRefs(innerRef, ref);
    const cursorPosition = useCursorPosition(value, innerRef, format);
    const maxLength = calcMaxLength(maxLengthProp);
    const handleOnChange = useCallback((rawValue, target) => {
        const value = unformat(rawValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(value, target);
    }, [onChange, maxLength]);
    const suffix = suffixProp
        ? React.isValidElement(suffixProp)
            ? React.cloneElement(suffixProp, {
                color: props.disabled
                    ? getColorByName(DarkNeutralsColorNames.color_neutrals_n_100)
                    : getColorByName(DarkNeutralsColorNames.color_neutrals_n_300),
                size: 24,
            })
            : undefined
        : undefined;
    return (React.createElement(BaseTextField, Object.assign({ value: format(value), placeholder: placeholder ? format(placeholder) : "", onChange: handleOnChange, cursorStart: cursorPosition, pattern: "^[\\s0-9\u06F0-\u06F9\u0660-\u0669]*$", inputMode: "numeric", prefix: React.createElement("div", { className: styles.PrefixNumber, "data-testid": datatestidPhonenumber },
            prefixNumber,
            React.createElement("div", { className: styles.Divider })), suffix: suffix, suffixClassName: clsx(styles.SuffixIcon, suffixClassName), ref: textFieldRef, direction: "ltr", contentDirection: "ltr", maxLength: maxLength }, props)));
};
export const PhoneNumberTextField = forwardRef(PhoneNumberTextFieldFC);
//# sourceMappingURL=PhoneNumberTextField.js.map